import { DocumentType } from '../config/DocumentType';

export const isOutgoingInvoice = (docTypeId) =>
  [DocumentType.DownPayment, DocumentType.ARInvoiceManual, DocumentType.ARInvoice, DocumentType.ARInvoiceModification]
    .includes(Number(docTypeId));

export const canRoundOutgoingInvoice = (values, autocompleteData) => {
  const currency = autocompleteData?.currency?.find((item) => item.code === values.currencyCode);
  const paymentMethod = autocompleteData?.paymentMethod?.find((item) => Number(item.id) === Number(values.paymentMethodId));
  return currency?.isoCode === 'HUF' && ['CASH', 'CASHREGISTER'].includes(paymentMethod?.defSettlementMode);
};

export const isValidInvoiceRounding = (value) =>
  Number.isInteger(Number(value)) && Number(value) >= -2 && Number(value) <= 2;
